import { Children, type ReactNode } from 'react';

import { ErrorDetail, Step1, Step2, Step3 } from '../../components';
import { useExcelImporterStepperContext } from '../../context';

type TUseGetStepsWithFallback = (
  children: ReactNode,
) => Record<number, ReactNode>;

export const useGetStepsWithFallback: TUseGetStepsWithFallback = children => {
  const { currentErrorRevision } = useExcelImporterStepperContext();
  const defaultSteps = {
    1: <Step1 />,
    2: (!currentErrorRevision && <Step2 />) || <ErrorDetail />,
    3: <Step3 />,
  };

  const childrenArray = children ? Children.toArray(children) : undefined;

  const childrenObject: Record<number, ReactNode> | undefined =
    childrenArray?.reduce(
      (acc: Record<number, ReactNode>, child: ReactNode, index: number) => {
        acc[index + 1] = child;
        return acc;
      },
      {},
    );

  return childrenObject ? childrenObject : defaultSteps;
};
